"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var error_1 = require("./error");
var componentToRx_1 = require("./componentToRx");
var keautils_1 = require("keautils");
var propsToRx_1 = require("./propsToRx");
var reselect_1 = require("reselect");
var defaultLoadingTimeout = 500;
/**Devuelve true si un elemento JSX es igual a otro */
function jsxEquals(a, b) {
    return (a.key === b.key &&
        a.type === b.type &&
        keautils_1.shallowEquals(a.props, b.props));
}
function compareCompType(a, b) {
    if (componentToRx_1.isJsxElement(a) || componentToRx_1.isJsxElement(b)) {
        //Uno si y otro no es JSX.element
        if (!componentToRx_1.isJsxElement(a) || !componentToRx_1.isJsxElement(b))
            return false;
        return jsxEquals(a, b);
    }
    return a === b;
}
var createSelectorJsx = reselect_1.createSelectorCreator(reselect_1.defaultMemoize, compareCompType);
var defaultLoadingSymbol = Symbol("defaultLoadingSymbol");
/**
 * Dibuja un component síncrono pasando props que aceptan promesas y observables.
 */
var Rx = /** @class */ (function (_super) {
    __extends(Rx, _super);
    function Rx() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.comp = function (x) { return x.render; };
        _this.loadingOrig = function (x) { return x.loading; };
        _this.loading = createSelectorJsx(_this.loadingOrig, function (x) { return x; });
        _this.errorOrig = function (x) { return x.error; };
        _this.error = createSelectorJsx(_this.errorOrig, function (x) { return x; });
        _this.optionsOrig = function (x) { return x.options; };
        _this.options = keautils_1.createDeepSelector(_this.optionsOrig, function (x) { return x; });
        _this.loadingTimeoutMs = function (x) { return x.loadingTimeoutMs; };
        _this.loadingSymbol = function (x) { return x.loadingSymbol; };
        _this.loadingEff = keautils_1.createSelector(_this.loading, _this.comp, function (Loading, Component) {
            return componentToRx_1.isJsxElement(Loading) ? (function () { return Loading; }) :
                (Loading || Component);
        });
        _this.errorEff = keautils_1.createSelector(_this.error, function (Error) {
            return componentToRx_1.isJsxElement(Error) ? (function () { return Error; }) :
                Error || error_1.ErrorView;
        });
        _this.obsRender = keautils_1.createSelector(_this.comp, _this.loadingEff, _this.errorEff, _this.options, _this.loadingTimeoutMs, _this.loadingSymbol, function (comp, loading, error, options, loadingTimeoutMs, loadingSymbol) {
            return function (props) { return componentToRx_1.renderComponentToRx(props, comp, loading, error, options, loadingTimeoutMs == null ? defaultLoadingTimeout : loadingTimeoutMs); };
        });
        return _this;
    }
    Rx.prototype.shouldComponentUpdate = function (nextProps) {
        var curr = this.props;
        var comps = {
            error: !compareCompType(curr.error, nextProps.error),
            loading: !compareCompType(curr.loading, nextProps.loading),
            loadingTimeoutMs: curr.loadingTimeoutMs != nextProps.loadingTimeoutMs,
            options: !keautils_1.deepEquals(curr.options, nextProps.options),
            render: curr.render != nextProps.render,
            props: !keautils_1.shallowEquals(curr.props, nextProps.props),
            loadingSymbol: curr.loadingSymbol != nextProps.loadingSymbol
        };
        var anyDiff = keautils_1.any(keautils_1.enumObject(comps).map(function (x) { return x.value; }), function (x) { return x == true; });
        return anyDiff;
    };
    Rx.prototype.render = function () {
        var render = this.obsRender(this.props);
        var passThru = componentToRx_1.allPropsIgnore(this.props.props, this.props.options);
        var syncRender = passThru ? this.props.render : undefined;
        return React.createElement(propsToRx_1.PropsToRx, { render: render, props: this.props.props, syncRender: syncRender });
    };
    return Rx;
}(React.Component));
exports.Rx = Rx;
/**
 * Devuelve un nuevo componente que acepta el valor singular, una promesa, o un observable en cualquiera de sus props, manejando correctamente el estado de cargando y de errores
 * @param Component Componente que se va a dibujar cuando todos los props han sido cargados y no exista ningún error de ningun observables/promesa
 * @param Loading Componente que se va a dibujar cuando existan props que aún estan cargando. Cargando implica que aún no se ha recibido ningún valor. Si es undefined se va a dibujar el componente, note que esto puede implicar que el componente reciva props como undefined cuando estas aún estén cargando
 * @param Error Componente que se va a dibujar cuando exista uno o mas props tales que su observable/promesa ha notificado de un error
 * @param options Opciones para los props
 */
function componentToRx(Component, Loading, Error, options, loadingTimeoutMs) {
    if (loadingTimeoutMs === void 0) { loadingTimeoutMs = 500; }
    return /** @class */ (function (_super) {
        __extends(ComponentToRx, _super);
        function ComponentToRx() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        ComponentToRx.prototype.render = function () {
            return React.createElement(Rx, { props: this.props, render: Component, loading: Loading, error: Error, options: options, loadingTimeoutMs: loadingTimeoutMs });
        };
        return ComponentToRx;
    }(React.PureComponent));
}
exports.componentToRx = componentToRx;
//# sourceMappingURL=rx.js.map


//////////////////
// WEBPACK FOOTER
// ./~/react-rxk/dist/rx.js
// module id = 2507
// module chunks = 0